import { Zap } from "lucide-react";

export default function VideoHeroBg({ mp4, webm, poster, posterAlt = "", badge = "IndiaFast Express", chip, testid = "service-hero-video" }) {
  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <img src={poster} alt={posterAlt} className="kenburns-a h-full w-full object-cover" />
      <video className="hero-video absolute inset-0 h-full w-full object-cover"
             autoPlay muted loop playsInline preload="metadata" poster={poster} data-testid={testid}>
        <source src={mp4} type="video/mp4" />
        <source src={webm} type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/70 to-navy/35" />
      <div className="floaty absolute right-6 top-24 hidden items-center gap-2.5 rounded-2xl border border-white/20 bg-navy/50 px-4 py-2.5 backdrop-blur-xl lg:flex"
           data-testid="service-hero-badge">
        <span className="grid h-8 w-8 place-items-center rounded-lg bg-saffron text-white shadow-lg shadow-saffron/40">
          <Zap className="h-4 w-4" fill="currentColor" />
        </span>
        <div>
          <p className="font-heading text-sm font-extrabold tracking-tight text-white">INDIA<span className="text-saffron">FAST</span></p>
          <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-white/60">{badge}</p>
        </div>
      </div>
      {chip && (
        <div className="floaty-slow absolute bottom-8 right-6 hidden rounded-xl border border-white/20 bg-white/10 px-3.5 py-2 backdrop-blur-xl lg:block"
             data-testid="service-hero-chip">
          <p className="font-mono text-[10px] text-slate-200">{chip.split("·")[0]?.trim()}</p>
          <p className="text-[10px] font-bold text-saffron">{chip.split("·")[1]?.trim()}</p>
        </div>
      )}
    </div>
  );
}
